import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('catalog-navigation', () => import(/* webpackMode: "lazy" */'./catalog-navigation'));
